// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/cmd/outcome_suggestion.proto (package morfi.v1.cmd, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/cmd/outcome_suggestion.proto.
 */
export const file_morfi_v1_cmd_outcome_suggestion: GenFile = /*@__PURE__*/
  fileDesc("CiVtb3JmaS92MS9jbWQvb3V0Y29tZV9zdWdnZXN0aW9uLnByb3RvEgxtb3JmaS52MS5jbWQitQQKFk91dGNvbWVTdWdnZXN0aW9uRXZlbnQSCgoCdHMYASABKAMSFQoNbWFya2V0X3B1YmtleRgCIAEoCRIVCg1zdWdnZXN0aW9uX2lkGAMgASgJEhgKEHN1Z2dlc3Rlcl9wdWJrZXkYBCABKAkSDQoFbGFiZWwYBSABKAkSDgoGdGlja2VyGAYgASgJEhEKCWltYWdlX3VybBgHIAEoCRIOCgZyZWFzb24YCCABKAkSDwoHdXB2b3RlcxgJIAEoBBIRCglkb3dudm90ZXMYCiABKAQSDQoFc2NvcmUYCyABKAMSOQoJc3VnZ2VzdGVyGAwgASgLMiYubW9yZmkudjEuY21kLk91dGNvbWVTdWdnZXN0ZXJJZGVudGl0eRIOCgZzdGF0dXMYDSABKAkSFwoPZ2VuZXJhdGlvbl9tb2RlGA4gASgJEhcKD3Byb3Bvc2FsX3B1YmtleRgPIAEoCRISCgpjcmVhdGVkX2F0GBAgASgDEhwKFGNyZWF0b3JfZWRpdGVkX2xhYmVsGBEgASgJEh0KFWNyZWF0b3JfZWRpdGVkX3RpY2tlchgSIAEoCRIgChhjcmVhdG9yX2VkaXRlZF9pbWFnZV91cmwYEyABKAkSHwoXcHJvbW90ZWRfb3V0Y29tZV9wdWJrZXkYFCABKAkSGgoNb3V0Y29tZV9pbmRleBgVIAEoDUgAiAEBEhMKC3Byb21vdGVkX2F0GBYgASgDQhAKDl9vdXRjb21lX2luZGV4IvYBChhPdXRjb21lU3VnZ2VzdGVySWRlbnRpdHkSDwoHdXNlcl9pZBgBIAEoCRIWCg53YWxsZXRfYWRkcmVzcxgCIAEoCRIUCgxkaXNwbGF5X25hbWUYAyABKAkSDgoGaGFuZGxlGAQgASgJEhIKCmF2YXRhcl91cmwYBSABKAkSEwoLYXZhdGFyX25zZncYBiABKAgSGAoQYXZhdGFyX3Jhc3RlcmlzZRgHIAEoCBJIChNjb25uZWN0ZWRfcHJvdmlkZXJzGAggAygLMisubW9yZmkudjEuY21kLk91dGNvbWVTdWdnZXN0ZXJQcm92aWRlckJhZGdlIlkKHU91dGNvbWVTdWdnZXN0ZXJQcm92aWRlckJhZGdlEhAKCHByb3ZpZGVyGAEgASgJEhAKCHVzZXJuYW1lGAIgASgJEhQKDGRpc3BsYXlfbmFtZRgDIAEoCWIGcHJvdG8z");

/**
 * @generated from message morfi.v1.cmd.OutcomeSuggestionEvent
 */
export type OutcomeSuggestionEvent = Message<"morfi.v1.cmd.OutcomeSuggestionEvent"> & {
  /**
   * @generated from field: int64 ts = 1;
   */
  ts: bigint;

  /**
   * @generated from field: string market_pubkey = 2;
   */
  marketPubkey: string;

  /**
   * uuid as string
   *
   * @generated from field: string suggestion_id = 3;
   */
  suggestionId: string;

  /**
   * @generated from field: string suggester_pubkey = 4;
   */
  suggesterPubkey: string;

  /**
   * @generated from field: string label = 5;
   */
  label: string;

  /**
   * @generated from field: string ticker = 6;
   */
  ticker: string;

  /**
   * @generated from field: string image_url = 7;
   */
  imageUrl: string;

  /**
   * empty string if null
   *
   * @generated from field: string reason = 8;
   */
  reason: string;

  /**
   * always 0 at create time
   *
   * @generated from field: uint64 upvotes = 9;
   */
  upvotes: bigint;

  /**
   * @generated from field: uint64 downvotes = 10;
   */
  downvotes: bigint;

  /**
   * @generated from field: int64 score = 11;
   */
  score: bigint;

  /**
   * resolved profile of suggester_pubkey
   *
   * @generated from field: morfi.v1.cmd.OutcomeSuggesterIdentity suggester = 12;
   */
  suggester?: OutcomeSuggesterIdentity | undefined;

  /**
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: string generation_mode = 14;
   */
  generationMode: string;

  /**
   * @generated from field: string proposal_pubkey = 15;
   */
  proposalPubkey: string;

  /**
   * @generated from field: int64 created_at = 16;
   */
  createdAt: bigint;

  /**
   * @generated from field: string creator_edited_label = 17;
   */
  creatorEditedLabel: string;

  /**
   * @generated from field: string creator_edited_ticker = 18;
   */
  creatorEditedTicker: string;

  /**
   * @generated from field: string creator_edited_image_url = 19;
   */
  creatorEditedImageUrl: string;

  /**
   * @generated from field: string promoted_outcome_pubkey = 20;
   */
  promotedOutcomePubkey: string;

  /**
   * @generated from field: optional uint32 outcome_index = 21;
   */
  outcomeIndex?: number | undefined;

  /**
   * @generated from field: int64 promoted_at = 22;
   */
  promotedAt: bigint;
};

/**
 * Describes the message morfi.v1.cmd.OutcomeSuggestionEvent.
 * Use `create(OutcomeSuggestionEventSchema)` to create a new message.
 */
export const OutcomeSuggestionEventSchema: GenMessage<OutcomeSuggestionEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_outcome_suggestion, 0);

/**
 * OutcomeSuggesterIdentity — the suggester's resolved profile, mirroring the
 * canonical `UserIdentity` wire shape the REST list endpoint returns under
 * `suggester`. Nullable strings use the empty-string sentinel (proto3 has no
 * null), matching the existing `reason` convention; the SDK row-builder maps
 * "" back to `null`.
 *
 * @generated from message morfi.v1.cmd.OutcomeSuggesterIdentity
 */
export type OutcomeSuggesterIdentity = Message<"morfi.v1.cmd.OutcomeSuggesterIdentity"> & {
  /**
   * app user UUID; "" if wallet-only
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * base58 pubkey (always present)
   *
   * @generated from field: string wallet_address = 2;
   */
  walletAddress: string;

  /**
   * "" if unset
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * "" if unset (no leading @)
   *
   * @generated from field: string handle = 4;
   */
  handle: string;

  /**
   * "" if unset
   *
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool avatar_nsfw = 6;
   */
  avatarNsfw: boolean;

  /**
   * avatarPreferences.rasterise
   *
   * @generated from field: bool avatar_rasterise = 7;
   */
  avatarRasterise: boolean;

  /**
   * @generated from field: repeated morfi.v1.cmd.OutcomeSuggesterProviderBadge connected_providers = 8;
   */
  connectedProviders: OutcomeSuggesterProviderBadge[];
};

/**
 * Describes the message morfi.v1.cmd.OutcomeSuggesterIdentity.
 * Use `create(OutcomeSuggesterIdentitySchema)` to create a new message.
 */
export const OutcomeSuggesterIdentitySchema: GenMessage<OutcomeSuggesterIdentity> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_outcome_suggestion, 1);

/**
 * OutcomeSuggesterProviderBadge — one verified social-account badge, mirroring
 * the REST `connectedProviders[]` entries.
 *
 * @generated from message morfi.v1.cmd.OutcomeSuggesterProviderBadge
 */
export type OutcomeSuggesterProviderBadge = Message<"morfi.v1.cmd.OutcomeSuggesterProviderBadge"> & {
  /**
   * "x" | "google" | "apple"
   *
   * @generated from field: string provider = 1;
   */
  provider: string;

  /**
   * "" if null
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * "" if null
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message morfi.v1.cmd.OutcomeSuggesterProviderBadge.
 * Use `create(OutcomeSuggesterProviderBadgeSchema)` to create a new message.
 */
export const OutcomeSuggesterProviderBadgeSchema: GenMessage<OutcomeSuggesterProviderBadge> = /*@__PURE__*/
  messageDesc(file_morfi_v1_cmd_outcome_suggestion, 2);

